import { analytics, db } from "@/firebase"
import { addDoc, collection, Timestamp } from "firebase/firestore"
import { logEvent } from "firebase/analytics" // Firebase Analytics logEvent 함수 import

export interface ChoiceClickData {
  // sessionId: string
  // choiceId: string
  ticketId: string
  choiceText: string
  timestamp: number
  userId?: string
}

export const recordChoiceClick = async (data: ChoiceClickData) => {
  try {
    // userId가 없는 경우 'anonymous'로 설정
    const enrichedData = {
      ...data,
      userId: data.userId ?? "anonymous",
      timestamp: Timestamp.fromMillis(data.timestamp),
    }

    // 개별 클릭 이벤트 기록
    await addDoc(collection(db, "choiceClicks"), enrichedData)
    logEvent(analytics, "chatbot_choice_click", {
      ticket_id: data.ticketId,
      choice_text: data.choiceText,
      user_id: enrichedData.userId,
    })

    return true
  } catch (error) {
    console.error("선택지 클릭 통계 기록 실패:", error)
    return false
  }
}
